<template>
	<div class='knd-custom-animation' >
    <svg  viewBox="0 0 322 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 10.559L266.924 10.559C273.851 10.559 279.466 16.1744 279.466 23.1013V23.1013C279.466 30.0282 285.081 35.6435 292.008 35.6435L321.5 35.6435" 
        stroke="#FFF" 
        stroke-width="0.5"
      />
      <circle r="3" fill="white" id="p1">
          <animateMotion
            dur="10"
            fill="white"
            delay="5"
            repeatCount="indefinite"
            path="M0 10.559L266.924 10.559C273.851 10.559 279.466 16.1744 279.466 23.1013V23.1013C279.466 30.0282 285.081 35.6435 292.008 35.6435L321.5 35.6435" />
        </circle>
<!-- 
        <circle r="3" fill="white">
          <animateMotion
            dur="15"
            fill="white"
            delay="5"
            gin="p1.begin+2s"
            repeatCount="indefinite"
            path="M0 10.559L266.924 10.559C273.851 10.559 279.466 16.1744 279.466 23.1013V23.1013C279.466 30.0282 285.081 35.6435 292.008 35.6435L321.5 35.6435" />
        </circle> -->

      </svg>

	</div>
</template>

<script>

export default {
  props: [],
  setup () {

    return {
    }
  }
}
</script>


<style lang="scss">
.knd-custom-animation {
  position: absolute;
  width: 100%;
  top: 35px;

  @include md { 
    display: none;
  }
  svg {
    width: 100%;

    circle {
      box-shadow: 0px 0px 3px 1px #FFFFFF;
      filter: blur(1px);
    }
  }
}

</style>